import { LANGUAGE_EN, LANGUAGE_ES, LANGUAGE_DE, LANGUAGE_FR } from 'services/languages/constants'
import {
  CONTENT_REFERENCE_TYPE_CATEGORY,
  CONTENT_REFERENCE_TYPE_CENTERS,
  CONTENT_REFERENCE_TYPE_CONTENT_ORIGIN,
  CONTENT_REFERENCE_TYPE_GENRES,
  CONTENT_REFERENCE_TYPE_INTERVIEW_GUEST,
  CONTENT_REFERENCE_TYPE_INTERVIEW_HOST,
  CONTENT_REFERENCE_TYPE_MARKETING_CENTERS,
  CONTENT_REFERENCE_TYPE_MEDITATION_DURATION,
  CONTENT_REFERENCE_TYPE_MEDITATION_FOCUS,
  CONTENT_REFERENCE_TYPE_MEDITATION_STYLE,
  CONTENT_REFERENCE_TYPE_MEDITATION_TEACHER,
  CONTENT_REFERENCE_TYPE_PRIMARY_COURSE,
  CONTENT_REFERENCE_TYPE_PRODUCT,
  CONTENT_REFERENCE_TYPE_RAINBOW_CATEGORY,
  CONTENT_REFERENCE_TYPE_SERIES,
  CONTENT_REFERENCE_TYPE_THIRD_PARTY_GENRE,
  CONTENT_REFERENCE_TYPE_YOGA_DURATION,
  CONTENT_REFERENCE_TYPE_YOGA_FOCUS,
  CONTENT_REFERENCE_TYPE_YOGA_LEVEL,
  CONTENT_REFERENCE_TYPE_YOGA_STYLE,
  CONTENT_REFERENCE_TYPE_YOGA_TEACHER,
} from 'services/content-references/types'
import { COURSE_FILTER_FIELD } from './columns'

/**
 * The order of the array affects behavior:
 * English First: The column shows English. Clicking edit shows English. Typing shows English results
 * French First: The column shows French. Clicking edit shows English. Typing shows French results
 * Because of https://gaiatv.atlassian.net/browse/EL-1065, we want English first
 */
export const DEFAULT_LANGUAGE_SELECTION = [LANGUAGE_EN]

export const LANGUAGE_SELECTION_OPTIONS = [
  { label: 'English', value: [LANGUAGE_EN] },
  { label: 'Spanish', value: [LANGUAGE_ES] },
  { label: 'German', value: [LANGUAGE_DE] },
  { label: 'French', value: [LANGUAGE_FR] },
  { label: 'English/Spanish', value: [LANGUAGE_EN, LANGUAGE_ES] },
  { label: 'English/German', value: [LANGUAGE_EN, LANGUAGE_DE] },
  { label: 'English/French', value: [LANGUAGE_EN, LANGUAGE_FR] },
]

export const SNACKBAR_DEFAULT_DURATION = 6000

export const SORT_DEFAULT = [{ field: 'publishedAtDate', sort: 'desc' }]

export const COLUMN_DEFAULT_VISIBILITY = {
  bundle: false,
  cast: false,
  [CONTENT_REFERENCE_TYPE_CATEGORY]: false,
  copyright: false,
  createdAt: false,
  description: false,
  displayType: false,
  featureMediaId: false,
  filterType: false,
  language: false,
  id: false,
  instructor: false,
  contentSearchNoIndex: false,
  excludeFromRecommendations: false,
  [CONTENT_REFERENCE_TYPE_INTERVIEW_GUEST]: false,
  [CONTENT_REFERENCE_TYPE_INTERVIEW_HOST]: false,
  [CONTENT_REFERENCE_TYPE_MARKETING_CENTERS]: false,
  [CONTENT_REFERENCE_TYPE_MEDITATION_DURATION]: false,
  [CONTENT_REFERENCE_TYPE_MEDITATION_FOCUS]: false,
  [CONTENT_REFERENCE_TYPE_MEDITATION_STYLE]: false,
  [CONTENT_REFERENCE_TYPE_MEDITATION_TEACHER]: false,
  [CONTENT_REFERENCE_TYPE_PRIMARY_COURSE]: false,
  [COURSE_FILTER_FIELD]: false,
  contentAssetReferences: false,
  previewMediaId: false,
  primaryLanguage: false,
  productType: false,
  studio: false,
  titleGroupId: false,
  titleId: false,
  unpublishedAt: false,
  updatedAt: false,
  weight: false,
  [CONTENT_REFERENCE_TYPE_YOGA_DURATION]: false,
  [CONTENT_REFERENCE_TYPE_YOGA_FOCUS]: false,
  [CONTENT_REFERENCE_TYPE_YOGA_LEVEL]: false,
  [CONTENT_REFERENCE_TYPE_YOGA_STYLE]: false,
  [CONTENT_REFERENCE_TYPE_YOGA_TEACHER]: false,
}

export const COLUMN_DEFAULT_ORDER = {
  // visible - defined order
  0: 'actions',
  1: 'contentId',
  2: 'contentType',
  3: 'title',
  4: CONTENT_REFERENCE_TYPE_SERIES,
  5: 'published',
  6: 'publishedAtDate',
  7: 'contentProviderProvider',
  8: 'path',
  9: 'seasonNumber',
  10: 'episodeNumber',
  11: CONTENT_REFERENCE_TYPE_RAINBOW_CATEGORY,
  12: CONTENT_REFERENCE_TYPE_CENTERS,
  13: CONTENT_REFERENCE_TYPE_PRODUCT,
  14: 'contentPolicyPolicyId',
  15: CONTENT_REFERENCE_TYPE_GENRES,
  16: CONTENT_REFERENCE_TYPE_THIRD_PARTY_GENRE,
  17: CONTENT_REFERENCE_TYPE_CONTENT_ORIGIN,
  // hidden - alphabetical order
  18: 'bundle',
  19: 'cast',
  20: CONTENT_REFERENCE_TYPE_CATEGORY,
  21: 'copyright',
  22: COURSE_FILTER_FIELD,
  23: 'createdAt',
  24: 'description',
  25: 'displayType',
  26: 'featureMediaId',
  27: 'filterType',
  28: 'id',
  29: 'excludeFromRecommendations',
  30: 'contentSearchNoIndex',
  31: 'instructor',
  32: CONTENT_REFERENCE_TYPE_INTERVIEW_HOST,
  33: CONTENT_REFERENCE_TYPE_INTERVIEW_GUEST,
  34: 'language',
  35: CONTENT_REFERENCE_TYPE_MARKETING_CENTERS,
  36: CONTENT_REFERENCE_TYPE_MEDITATION_DURATION,
  37: CONTENT_REFERENCE_TYPE_MEDITATION_FOCUS,
  38: CONTENT_REFERENCE_TYPE_MEDITATION_STYLE,
  39: CONTENT_REFERENCE_TYPE_MEDITATION_TEACHER,
  40: 'contentAssetReferences',
  41: 'previewMediaId',
  42: 'primaryLanguage',
  43: CONTENT_REFERENCE_TYPE_PRIMARY_COURSE,
  44: 'productType',
  45: 'titleGroupId',
  46: 'titleId',
  47: 'studio',
  48: 'updatedAt',
  49: 'unpublishedAt',
  50: 'weight',
  51: CONTENT_REFERENCE_TYPE_YOGA_DURATION,
  52: CONTENT_REFERENCE_TYPE_YOGA_FOCUS,
  53: CONTENT_REFERENCE_TYPE_YOGA_LEVEL,
  54: CONTENT_REFERENCE_TYPE_YOGA_STYLE,
  55: CONTENT_REFERENCE_TYPE_YOGA_TEACHER,
}

export const COLUMN_DEFAULT_PINS = {
  left: ['actions'],
  right: [],
}
